import { Admin, Resource, fetchUtils, Layout, Menu, MenuItemLink, DashboardMenuItem, CustomRoutes } from 'react-admin';
import { Route } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import jsonServerProvider from 'ra-data-json-server';
import ArmyList from './ArmyList';
import ArmyEdit from './ArmyEdit';
import UserCreate from './UserCreate';
import UserList from './UserList';
import UserEdit from './UserEdit';
import PlayersUpload from './PlayersUpload';
import { icons } from '../../assets/icons/Icons';

const httpClient = (url, options = {}) => {
  const token = window.localStorage.getItem("loggedBLUser");
  options.headers = new Headers(options.headers || {});

  if (token) {
    options.headers.set('Authorization', `Bearer ${token}`);
  }
  return fetchUtils.fetchJson(url, options);
};

const apiUrl = process.env.REACT_APP_API_URL || '/api';

const dataProvider = jsonServerProvider(apiUrl, httpClient);

const CustomDashboard = () => {
  const theme = useTheme();
  return (
    <div style={{ padding: '20px', color: theme.palette.text.primary }}>
      <h3>Welcome to the Admin Dashboard</h3>
      <p>Use the navigation menu to manage resources.</p>
    </div>
  );
};

const CustomMenu = (props) => {
  return (
    <Menu {...props}>
      <DashboardMenuItem />
      <MenuItemLink to="armies" primaryText="Armies" leftIcon={<icons.GiKnightBanner size={26} />} />
      <MenuItemLink to="users" primaryText="Users" leftIcon={<icons.FaUser size={22} />} />
      <MenuItemLink to="players-upload" primaryText="Players Upload" leftIcon={<icons.FaFileCsv size={22} />} />
      <MenuItemLink
        to="#"
        primaryText="Back to Map"
        leftIcon={<icons.FaMapMarkedAlt size={22} />}
        onClick={() => { window.location.href = '/'; }}
      />
    </Menu>
  );
};

const CustomLayout = (props) => <Layout {...props} menu={CustomMenu} />;

const AdminDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = window.localStorage.getItem("loggedBLUser");
    if (!token) {
      navigate('/');
      return;
    }
    try {
      const decoded = jwtDecode(token);
      console.log('Decoded token:', decoded); // Debug: Check token contents
      if (decoded.role !== "admin") {
        navigate('/');
      }
    } catch (error) {
      // Invalid token
      navigate('/');
    }
  }, [navigate]);

  return (
    <Admin
      basename="/admin"
      dataProvider={dataProvider}
      dashboard={CustomDashboard}
      layout={CustomLayout}
    >
      <Resource name="armies" list={ArmyList} edit={ArmyEdit} />
      <Resource name="users" list={UserList} edit={UserEdit} create={UserCreate} />
      <CustomRoutes>
        <Route path="players-upload" element={<PlayersUpload />} />
      </CustomRoutes>
    </Admin>
  );
};

export default AdminDashboard;
